import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=ae28da3c&scoped=true&"
import script from "./welcome.vue?vue&type=script&lang=js&"
export * from "./welcome.vue?vue&type=script&lang=js&"
import style0 from "./welcome.vue?vue&type=style&index=0&id=ae28da3c&prod&lang=css&"
import style1 from "./welcome.css?vue&type=style&index=1&id=ae28da3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae28da3c",
  null
  
)

export default component.exports